import { render } from "./AcceptanceCriteriaCard.vue?vue&type=template&id=bb5dbf80"
import script from "./AcceptanceCriteriaCard.vue?vue&type=script&lang=js"
export * from "./AcceptanceCriteriaCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__